import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Cerrar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _ctx.snackbar,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.snackbar) = $event)),
    color: _ctx.snackbarColor,
    class: "title",
    timeout: -1
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.snackbarMessage) + " ", 1),
      _createVNode(_component_v_btn, {
        dark: "",
        text: "",
        onClick: _ctx.snackbarHide
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["modelValue", "color"]))
}